import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PolymerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"polymer"}/>
}
